module.exports = __webpack_public_path__ + "static/media/Bahrain.1ad6a225.png";